(() => {
  const mountingVariant = 60863595413838;
  const engravingVariant = 60863568838990;
  let busy = false;

  const root = () => window.Shopify?.routes?.root || '/';
  const isCharge = item => [mountingVariant, engravingVariant].includes(Number(item.variant_id));

  async function synchronize(event) {
    const target = event.target.closest('[data-pk-action="decrease-quantity"], [data-pk-action="increase-quantity"], .quantity-selector:not(.quantity-selector--product) .quantity-selector__value');
    if (!target || !target.closest('[data-pk-type="cart"], .pk-side-cart')) return;
    const row = target.closest('[data-medal-link]');
    if (!row || row.hasAttribute('data-medal-charge')) return;

    const line = Number(target.dataset.line);
    if (!Number.isInteger(line) || line < 1) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    try {

    const cartResponse = await fetch(root() + 'cart.js', { credentials: 'same-origin' });
    if (!cartResponse.ok) throw new Error('Warenkorb konnte nicht gelesen werden.');
    const cart = await cartResponse.json();
    const medal = cart.items[line - 1];
    const link = medal?.properties?.['_Gravur-Verknüpfung'];
    if (!link || link !== row.dataset.medalLink || isCharge(medal)) throw new Error('Medaillenposition hat sich geändert.');

    const quantity = Number(target.tagName === 'INPUT' ? target.value : target.dataset.quantity);
    if (!Number.isInteger(quantity) || quantity < 0) {
      if (target.tagName === 'INPUT') target.value = medal.quantity;
      busy = false;
      return;
    }

      const changed = await fetch(root() + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: medal.key, quantity })
      });
      if (!changed.ok) throw new Error('Medaillenmenge konnte nicht geändert werden.');
      const updatedCart = await changed.json();
      const updates = {};
      for (const item of updatedCart.items) {
        if (item.properties?.['_Gravur-Verknüpfung'] !== link || !isCharge(item)) continue;
        const units = Number(item.variant_id) === engravingVariant
          ? Number(item.properties?.['_Zeichen je Medaille']) * quantity
          : quantity;
        if (!Number.isInteger(units) || units < 0) throw new Error('Der Aufpreis konnte nicht berechnet werden.');
        updates[item.key] = units;
      }
      if (Object.keys(updates).length) {
        const synced = await fetch(root() + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ updates })
        });
        if (!synced.ok) throw new Error('Aufpreise konnten nicht aktualisiert werden.');
      }
      window.location.reload();
    } catch (error) {
      console.error(error);
      alert('Die Menge konnte nicht vollständig aktualisiert werden. Bitte prüfen Sie den Warenkorb.');
      window.location.reload();
    }
  }

  document.addEventListener('click', event => {
    if (event.target.closest('[data-pk-action="decrease-quantity"], [data-pk-action="increase-quantity"]')) {
      synchronize(event).catch(error => console.error(error));
    }
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches('.quantity-selector:not(.quantity-selector--product) .quantity-selector__value')) {
      synchronize(event).catch(error => console.error(error));
    }
  }, true);
})();
